import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useUser } from "@foundation/altzero_base/base/contextapi/UserContext";
import { supabase } from "../utils/supabaseClient";
import ScopingAISidebar from "./ScopingAISidebar";

interface ScopingAILayoutProps {
  children: React.ReactNode;
}

export default function ScopingAILayout({ children }: ScopingAILayoutProps) {
  return (
    <div className="flex min-h-[calc(100vh-4rem)] bg-gray-50">
      <ScopingAISidebar />
      <div className="flex-1 flex flex-col">
        <main className="flex-1">{children}</main>
      </div>
    </div>
  );
}
